import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=44733cd2&scoped=true&"
import script from "./ArticleInfo.vue?vue&type=script&lang=js&"
export * from "./ArticleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=44733cd2&lang=less&scoped=true&"
import style1 from "./ArticleInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44733cd2",
  null
  
)

export default component.exports